var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "margin-top": "1px" },
      attrs: {
        width: "15",
        height: "15",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M17 8H4.83L10.42 2.41L9 1L1 9L9 17L10.41 15.59L4.83 10H5V8Z",
          fill: _vm.fill,
          stroke: "",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }